import apiClient from './client';
import type { TaxonomyStatus } from './skillsTaxonomy';

// The Skills Library catalog read (skills_library_spec.md §5). Mutations
// (repoint, alias deprecate/reactivate, node deactivate/activate) reuse the
// existing curation endpoints in `skillsTaxonomy.ts`.

const V2_BASE = '/api/v2';
const ROOT = '/skills-taxonomy';

/** One origin source type. Open vocab in storage; only these two are rendered. */
export type Origin = 'CV' | 'TENDER';

/** An alias resolving to a catalog skill (both active and deprecated are listed). */
export interface LibraryAlias {
  id: string;
  /** Stored (normalized) surface form — normalized display at MVP (D5). */
  text: string;
  status: TaxonomyStatus;
  origins: Origin[];
}

/** One catalog row. */
export interface LibrarySkill {
  id: string;
  name: string;
  /** Null at MVP (D1 — dropped). */
  description: string | null;
  /** `kind = category` ancestors via is_a (D2). */
  labels: string[];
  origins: Origin[];
  /** Distinct CV entities (people) — D3. */
  assigned: number;
  status: TaxonomyStatus;
  aliases: LibraryAlias[];
}

/** An alphabetical group: uppercased first letter, a count, and its skills. */
export interface LibraryGroup {
  letter: string;
  count: number;
  skills: LibrarySkill[];
}

export interface SkillsLibrary {
  groups: LibraryGroup[];
}

/** Fetch the full grouped catalog (includes deprecated nodes and aliases, §3.5). */
export async function fetchSkillsLibrary(): Promise<SkillsLibrary> {
  const { data } = await apiClient.get<SkillsLibrary>(`${ROOT}/library`, { baseURL: V2_BASE });
  return data;
}
